"use strict";

//smoothscroll

$('a[href^="#"]').click(function () {
  var speed = 700;
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;
  $('body,html').animate({
    scrollTop: position
  }, speed, 'swing');
  return false;
});


//menu
$('#header-toggle').on("click", function () {
  $('.header-menu').toggleClass('is-open');
  $(this).toggleClass('is-open');
});

$('.header-menu__item').on("click", function () {
  $('.header-menu').removeClass('is-open');
  $('#header-toggle').removeClass('is-open');
});


//scroll anime


function headerToggleClass() {
  // 現在のスクロール量
  var headerScrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  // 画面の1/2を超えたら、classを追加
  if (headerScrollTop > 0) {
    $("#header").addClass("is-fixed");
  } else {
    $("#header").removeClass("is-fixed");
  }
}

function addClassWithScroll(trigger, selector, className, triggerPercent) {
  $(trigger).each(function () {
    // windowの高さ - a
    var windowHeight = window.document.documentElement.clientHeight;
    // 画面左上から要素までの高さ - b
    var offset = $(this).offset().top;

    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = offset - windowHeight;
    // 現在のスクロール量
    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    // 画面の1/2を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / triggerPercent) {
      $(this).addClass(className);
    } else {
      // $(selector).removeClass(className);
    }
  });
}

var mediaQuery = matchMedia('(max-width: 768px)');
handle(mediaQuery);
mediaQuery.addListener(handle);

function handle(mq) {
  if (mq.matches) {

    $(window).on("scroll", function () {
      headerToggleClass();
      addClassWithScroll(".lead", this, "is-anime", 4);
      addClassWithScroll(".sec-point__box", this, "is-anime", 4);
      addClassWithScroll(".sec-point__figure", this, "is-anime", 2);
      addClassWithScroll(".sec-voice", ".sec-voice-box", "is-anime", 4);
      addClassWithScroll(".sec-schedule-box", this, "is-anime", 4);
      addClassWithScroll(".sec-schedule-box__graph", '.sec-schedule-box', "is-anime", 4);
      addClassWithScroll(".sec-instagram ", ".sec-instagram ", "is-anime", 4);
      addClassWithScroll(".sec-flow__ttl", this, "is-anime", 4);
      addClassWithScroll(".sec-flow-box", this, "is-anime", 2);
      addClassWithScroll(".sec-flow-step", this, "is-anime", 2);
      addClassWithScroll(".sec-flow-step-link ", this, "is-anime", 6);
    });

  } else {

    $(window).on("scroll", function () {
      headerToggleClass();
      addClassWithScroll(".lead", this, "is-anime", 2);
      addClassWithScroll(".sec-point__box", this, "is-anime", 2);
      addClassWithScroll(".sec-point__figure", this, "is-anime", 2);
      addClassWithScroll(".sec-voice", ".sec-voice-box", "is-anime", 2);
      addClassWithScroll(".sec-schedule-box", this, "is-anime", 8);
      addClassWithScroll(".sec-schedule-box__graph", '.sec-schedule-box', "is-anime", 8);
      addClassWithScroll(".sec-instagram ", ".sec-instagram ", "is-anime", 2);
      addClassWithScroll(".sec-flow__ttl", this, "is-anime", 2);
      addClassWithScroll(".sec-flow-box", this, "is-anime", 2);
      addClassWithScroll(".sec-flow-step", this, "is-anime", 2);
      addClassWithScroll(".sec-flow-step-link ", this, "is-anime", 6);
    });

  }
}
